export class Faq {
    constructor() {
        this.setProperties();
        this.setEvents();
    }

    setProperties () {
        this.$search = $( '#faq-search' );
        this.$wrapper = $( '#faq-wrapper' );
        this.$cards = this.$wrapper.find( '.card' );
        this.$noResults = $( '.faq-no-results' );
        this.$clear = $( '.faq-search-clear' );
    }

    setEvents () {
        this.$search.on( 'input change', () => {
            this.performSearch();
        } );

        this.$clear.on( 'click', () => {
            this.$search.val( '' ).trigger( 'change' );
        } );
    }

    performSearch () {
        let self = this,
            fraze = this.$search.val().toLowerCase();

        this.$noResults.removeClass( 'active' );

        if ( '' === fraze ) {
            this.$cards.removeClass( 'hidden' );
            this.$clear.removeClass( 'active' );
        } else {
            this.$clear.addClass( 'active' );

            this.$cards.each( function () {
                let $this = $( this ),
                    $title = $this.find( '.btn' ),
                    $content = $this.find( '.card-body' );

                if ( $title.text().toLowerCase().includes( fraze ) || $content.text().toLowerCase().includes( fraze ) ) {
                    $this.removeClass( 'hidden' );
                } else {
                    $this.addClass( 'hidden' );
                }
            } );

            if ( 0 === this.$wrapper.find( '.card:not(.hidden)').length ) {
                this.$noResults.addClass( 'active' );
            }
        }
    }
}
